import { render, staticRenderFns } from "./RejectionDescription.vue?vue&type=template&id=9793daf2&"
import script from "./RejectionDescription.vue?vue&type=script&lang=js&"
export * from "./RejectionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports